import React, {useEffect} from 'react'
import Aos from 'aos';

const CTA = () => {
   useEffect(() =>{
          Aos.init({
          duration: 1000, 
          easing: 'ease-in-out', 
          once: false,  
          offset: 100, 
          });
        }, [])
  return (
    <div id='cta'>
        <div className='cta' data-aos ="fade-up">
         <div>
           <p>Got a project in mind? </p>
           <hr />
           {/* <h1>Let me turn ideas into reality with clean code and stunning design.</h1> */}
           <h1>Let's Build Something Amazing!</h1>
         </div>
         {/* <button data-aos = 'slide-left'>Get In Touch</button> */}
                   <a href="mailto:glitsejohnray@gmail.com?subject=Hello&body=I'd%20like%20to%20get%20in%20touch%20with%20you.">
                    <button>Get In Touch</button>
                    </a>

        </div>     
    </div>

  )
}

export default CTA